import { GET_METAL_TYPES_SUCCESS } from "../actionTypes";

const initialState = [];

export default function(state = initialState, action) {
  switch (action.type) {
    case GET_METAL_TYPES_SUCCESS: {
      const metalTypes = action.payload;

      if (!metalTypes){
        return [...state];
      }

      return [
        ...state,
        ...metalTypes
      ]
    }
    default:
      return state;
  }
}
